export type UserManagementUsersAction =
    | 'add'
    | 'edit'
    | 'extra-permissions'
    | 'extra-tags'
    | 'assign-reports'
    | 'toggle-active'
    | 'enable-otp';

export interface UserManagementUsersRoute {
    action: UserManagementUsersAction | null;
    id: string | null;
}

const BASE_PATH = '/user_management/users';

const VALID_ACTIONS: UserManagementUsersAction[] = [
    'add',
    'edit',
    'extra-permissions',
    'extra-tags',
    'assign-reports',
    'toggle-active',
    'enable-otp',
];

export const buildUserManagementUsersBasePath = (): string => BASE_PATH;

export const buildUserManagementUsersActionPath = (
    action: UserManagementUsersAction,
    id?: string | number | null
): string => {
    if (action === 'add') {
        return `${BASE_PATH}/add`;
    }

    if (id === undefined || id === null || id === '') {
        return BASE_PATH;
    }

    return `${BASE_PATH}/${action}/${encodeURIComponent(String(id))}`;
};

export const parseUserManagementUsersRoute = (
    pathname: string
): UserManagementUsersRoute => {
    const segments = pathname.split('/').filter(Boolean);

    if (segments[0] !== 'user_management' || segments[1] !== 'users') {
        return { action: null, id: null };
    }

    const action = segments[2] as UserManagementUsersAction | undefined;
    if (!action || !VALID_ACTIONS.includes(action)) {
        return { action: null, id: null };
    }

    if (action === 'add') {
        return { action, id: null };
    }

    const rawId = segments[3];
    if (!rawId) {
        return { action: null, id: null };
    }

    return {
        action,
        id: decodeURIComponent(rawId),
    };
};